import React, { useEffect, useState, createElement, Component } from 'react';
import { motion, AnimatePresence, useScroll, useMotionValueEvent } from 'framer-motion';
import { Star, Heart, MessageCircle, CheckCircle2, CreditCard, Users, Ticket, ChevronRight, X, Shield, Calendar, Infinity as InfinityIcon, Handshake, ChevronDown, HelpCircle, Camera, Scissors, Ruler, Circle, Flower2, Wind } from 'lucide-react';
// --- Constants & Data ---
const CHECKOUT_LINK = 'https://primex-digital.shop/cart/45146186350701:1';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/2SoAtef4NiCor3Zs6PDdC7/ChatGPT_Image_11_may_2026,_19_54_50.webp';
const HERO_BG = 'https://cdn.magicpatterns.com/uploads/hyRjcsCfC9oubUGBy62xij/sacame_el_titulo_202604231454.jpg';
const PROJECTS = [{
  url: 'https://cdn.magicpatterns.com/uploads/pMWq4JR7FnjaSZZU2446tR/5158e4e59a7d042ea5975afe651f836c.webp',
  title: 'Accesorios para Bebé',
  comment: 'Ternura en cada puntada para los momentos que más importan.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/1AmhZCg4JuGVvYDXcfopVZ/135fe2964978e887e20de89fee426b24.webp',
  title: 'Primeras Prendas',
  comment: 'Un abrazo de tela hecho con paciencia y dedicación.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/sAbf5ScvvtYPZDBfoNMeMv/840fca2308241e19189d5b1848b95db7.webp',
  title: 'Costura con Técnica',
  comment: 'La satisfacción de ver cómo un trazo se convierte en realidad.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/hnTur4po3AyrVuevgCsmNY/51a6773011984814d911793d1a0dd987.webp',
  title: 'Textiles de Hogar',
  comment: 'Creando espacios que invitan a compartir y disfrutar.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/tgRAsveZeZCAjsFv6mWjQk/8871b7fd9beeaf4e66ecc15a9520134d.webp',
  title: 'Diseños con Alma',
  comment: 'Tu creatividad plasmada en prendas que inspiran a crear.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/b74duinN94Cjb7K7YLY1QM/9e2346c3b3b1fcc362b24abd16d4421b.webp',
  title: 'Blusa Romántica en Lino',
  comment: 'La elegancia de lo simple, capturada en una prenda que trasciende temporadas.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/pV4sKDP642VaPF2pH8NRNN/73ab0ccb727afdda53cecada3b9338f0.webp',
  title: 'Set de Bienvenida Fox',
  comment: 'Preparando el nido con amor y las telas más suaves para la piel del bebé.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/3ktAe5fsrSzeyvDW6wRxXo/6c50b2bbaa813db148fe63e0e4e316fc.webp',
  title: 'Mesa con Estilo Atelier',
  comment: 'Detalles que transforman lo cotidiano en una experiencia gourmet en casa.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/gYr1rXhjHdNXrRqycmtTqg/6d668eba2062c5dd18c7704c336b4515.webp',
  title: "Abrigo de Lluvia 'Paws'",
  comment: 'Porque ellos también merecen lucir impecables mientras exploran el mundo.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/w25NbnBVKBU1NuhbknDdW6/11e2e0b67ec4ed77f370028a35110a31.webp',
  title: 'El Arte del Calce Perfecto',
  comment: 'Dominar el denim es el paso final para convertirte en una experta de la moda.'
}];
const BONUSES = [{
  id: 1,
  title: 'BONO #1 - ATELIER DE CREACIÓN',
  desc: '+2000 Moldes Profesionales en todas las tallas and categorías. Una biblioteca infinita de posibilidades para que nunca te falte inspiración ni proyectos por crear.',
  img: 'https://cdn.magicpatterns.com/uploads/ru5vELTfC8PkEJbBEvS8qm/ChatGPT_Image_27_may_2026,_21_09_40.webp'
}, {
  id: 2,
  title: 'BONO #2 - HOGAR CON ALMA',
  desc: 'Proyectos creativos para decorar, organizar y transformar tu hogar. Aprende a crear espacios acogedores y llenos de inspiración femenina con tus propias manos.',
  img: 'https://cdn.magicpatterns.com/uploads/unwuwjatb3kRLwqJPs54Vs/ChatGPT_Image_27_may_2026,_21_11_44.png'
}, {
  id: 3,
  title: 'BONO #3 - TU MARCA TEXTIL',
  desc: 'Kit completo de branding, etiquetas y catálogo para emprendedoras textiles. Todo lo que necesitas para proyectar una imagen profesional y empezar a vender tus creaciones.',
  img: 'https://cdn.magicpatterns.com/uploads/kJaciTwKY5rkcHHcoHXxvz/ChatGPT_Image_27_may_2026,_21_13_41.webp'
}, {
  id: 4,
  title: 'BONO #4 - COSTURA DESDE CERO',
  desc: 'Aprende paso a paso los fundamentos de la costura desde nivel principiante. Pierde el miedo a la máquina y domina las técnicas básicas con total confianza y calma.',
  img: 'https://cdn.magicpatterns.com/uploads/cjUWvJSKRLQacpjNzTyxJ2/ChatGPT_Image_27_may_2026,_21_17_49.webp'
}];
const TESTIMONIALS = [{
  name: 'Marta G.',
  text: 'No puedo creer lo que estoy viendo, los moldes son clarísimos. Antes me volvía loca con los tutoriales de YouTube que no explicaban bien. ¡Mil gracias!',
  rating: 5
}, {
  name: 'Silvia de Cordoba',
  text: 'Lo compré ayer y ya terminé mi primer vestido. Quedó divino, calza perfecto. Valió cada peso invertido.',
  rating: 5
}, {
  name: 'Graciela',
  text: 'Al principio dudaba por el miedo a no saber usar la máquina, pero la verdad que la pedagogía es otra cosa. Se nota que enseñan con amor.',
  rating: 4
}, {
  name: 'Mirta R.',
  text: 'Estaba cansada de descoser todo el tiempo. Con Alma Textil por fin me sale todo a la primera. ¡Re contenta y motivada!',
  rating: 5
}, {
  name: 'Elena',
  text: 'Muy bueno todo, los bonos son geniales. El de Tu Marca Textil me dio el empujón para empezar a vender.',
  rating: 5
}];
const ARG_CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén'];
const NAMES = ['Maria', 'Ana', 'Juana', 'Beatriz', 'Graciela', 'Marta', 'Silvia', 'Elena', 'Patricia', 'Rosa'];
// --- Countdown Timer Component ---
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState<{
    minutes: number;
    seconds: number;
  } | null>(null);
  useEffect(() => {
    const STORAGE_KEY = 'hilos_enamoran_timer_end';
    const FIFTEEN_MINUTES = 15 * 60 * 1000;
    const getEndTime = () => {
      let stored = localStorage.getItem(STORAGE_KEY);
      const now = Date.now();
      if (!stored || isNaN(parseInt(stored)) || now > parseInt(stored)) {
        const newEnd = now + FIFTEEN_MINUTES;
        localStorage.setItem(STORAGE_KEY, newEnd.toString());
        return newEnd;
      }
      return parseInt(stored);
    };
    let endTime = getEndTime();
    const updateTimer = () => {
      const now = Date.now();
      const difference = endTime - now;
      if (difference <= 0) {
        endTime = now + FIFTEEN_MINUTES;
        localStorage.setItem(STORAGE_KEY, endTime.toString());
      }
      const minutes = Math.floor(Math.max(0, difference) / 1000 / 60 % 60);
      const seconds = Math.floor(Math.max(0, difference) / 1000 % 60);
      setTimeLeft({
        minutes,
        seconds
      });
    };
    // Initial call
    updateTimer();
    const timer = setInterval(updateTimer, 1000);
    return () => clearInterval(timer);
  }, []);
  if (!timeLeft) return null;
  return <div className="flex items-center gap-1 ml-[22px] pl-[22px] pr-[22px] mr-[30px]" data-id="element-0">
      <span className="text-sm font-black tabular-nums text-[#2F5233] pl-[2px] pr-[2px]" data-id="element-1">
        {timeLeft.minutes.toString().padStart(2, '0')}:
        {timeLeft.seconds.toString().padStart(2, '0')}
      </span>
    </div>;
};
// --- Custom Icons ---
const YarnBallIcon = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-2">
    <circle cx="12" cy="12" r="10" data-id="element-3" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10" data-id="element-4" />
    <path d="M12 2a15.3 15.3 0 0 0-4 10 15.3 15.3 0 0 0 4 10" data-id="element-5" />
    <path d="M2 12h20" data-id="element-6" />
    <path d="M12 2v20" data-id="element-7" />
    <path d="M7 7l10 10" data-id="element-8" />
    <path d="M7 17L17 7" data-id="element-9" />
  </svg>;
const PremiumCTAButton = ({
  onClick,
  className = ''
}: {
  onClick: () => void;
  className?: string;
}) => <motion.button onClick={onClick} whileHover={{
  scale: 1.03,
  brightness: 1.1
}} whileTap={{
  scale: 0.97
}} className={`${`${`${`${`${`${`${`${`${`relative group flex flex-col items-center justify-center bg-gradient-to-br from-[#fdf2f2] via-[#E07A5F] to-[#D1694E] text-white rounded-[2.5rem] shadow-[0_15px_35px_rgba(224,122,95,0.3)] border border-[#D4AF37]/40 overflow-hidden transition-all duration-500 animate-float-slow animate-shine-slow ${className}`} pl-[4px] mb-[6px] ml-[150px] flex-col items-center justify-center`} pl-[4px] mb-[6px] ml-[150px] flex-col items-center justify-center`} pt-[22px] ml-[150px]`} items-center justify-start`} pt-[20px] pb-[10px] mt-[22px] mb-[22px] items-center justify-center`} pb-[0px] items-center justify-center`} mt-[10px] mb-[22px]`} mt-[20px] mb-[222px]`} mb-[25px]`} data-id="element-10">
    {/* Glossy overlay */}
    <div className="absolute inset-0 bg-gradient-to-b from-white/20 to-transparent pointer-events-none" data-id="element-11" />

    <div className="relative z-10 py-4 px-10 md:py-6 md:px-14 flex flex-col gap-0.5 pt-[0px] pb-[3px] pr-[3px] pl-[2px] items-center justify-center" data-id="element-12">
      <span className="md:text-2xl font-bold tracking-wider uppercase font-serif drop-shadow-sm text-[12px]" data-id="element-13">
        QUIERO APRENDER
      </span>
      <span className="text-xs md:text-sm font-medium italic opacity-90 lowercase font-serif" data-id="element-14">
        y acceder ahora
      </span>
    </div>

    {/* Subtle glow on hover */}
    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-white/10 blur-xl pointer-events-none" data-id="element-15" />
  </motion.button>;
const CTAButton = ({
  onClick,
  className = ''
}: {
  onClick: () => void;
  className?: string;
}) => <button onClick={onClick} className={`w-full max-w-2xl mx-auto text-white font-black py-10 rounded-[2.5rem] shadow-2xl hover:bg-[#1F3A22] active:scale-[0.98] transition-all flex uppercase mb-6 animate-slow-pulse flex-col items-center justify-center text-[28px] bg-[#32B742] gap-[16px] pt-[10px] pb-[10px] ${className}`} data-id="element-16">
    ¡SÍ, LO QUIERO!
  </button>;
// --- Components ---
const PurchasePopup = () => {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const show = () => {
      setData({
        name: NAMES[Math.floor(Math.random() * NAMES.length)],
        city: ARG_CITIES[Math.floor(Math.random() * ARG_CITIES.length)]
      });
      setVisible(true);
      setTimeout(() => setVisible(false), 6000);
    };
    // Changed interval to 45 seconds to be less annoying
    const interval = setInterval(show, 45000);
    setTimeout(show, 8000); // Initial delay
    return () => clearInterval(interval);
  }, []);
  return <AnimatePresence data-id="element-17">
      {visible && <motion.div initial={{
      x: -100,
      opacity: 0,
      scale: 0.8
    }} animate={{
      x: 20,
      opacity: 1,
      scale: 1
    }} exit={{
      x: -100,
      opacity: 0,
      scale: 0.8
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-10 left-0 z-50 bg-white/95 backdrop-blur-md p-1 rounded-3xl shadow-[0_20px_50px_rgba(47,82,51,0.15)] flex items-center gap-4 border border-[#2F5233]/20 max-w-[320px] overflow-hidden" data-id="element-18">
          <div className="relative" data-id="element-19">
            <div className="bg-gradient-to-br from-[#E07A5F] to-[#D1694E] p-3 rounded-2xl shadow-inner" data-id="element-20">
              <YarnBallIcon className="text-white w-6 h-6 animate-spin-slow" data-id="element-21" />
            </div>
            <div className="absolute -top-1 -right-1 bg-[#2F5233] rounded-full p-1 border-2 border-white" data-id="element-22">
              <CheckCircle2 className="text-white w-2 h-2" data-id="element-23" />
            </div>
          </div>
          <div className="pr-4 py-2" data-id="element-24">
            <p className="text-sm font-bold text-[#2F5233] leading-tight" data-id="element-25">
              ¡{data.name} de {data.city}!
            </p>
            <p className="text-[11px] text-[#8D7B6D] font-medium" data-id="element-26">
              Acaba de unirse a la academia 🪡
            </p>
            <div className="mt-1 flex items-center gap-1" data-id="element-27">
              <div className="flex gap-0.5" data-id="element-28">
                {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-2 h-2 fill-[#E07A5F] text-[#E07A5F]" data-id="element-29" />)}
              </div>
              <span className="text-[9px] text-[#E07A5F] font-bold uppercase tracking-tighter" data-id="element-30">
                Compra Verificada
              </span>
            </div>
          </div>
          <div className="absolute right-0 top-0 bottom-0 w-1 bg-gradient-to-b from-[#E07A5F] via-[#2F5233] to-[#E07A5F]" data-id="element-31" />
        </motion.div>}
    </AnimatePresence>;
};
const StickyHeader = ({
  onAction
}: {
  onAction: () => void;
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    if (latest > 400) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  });
  return <AnimatePresence data-id="element-32">
      {isVisible && <motion.div initial={{
      y: -100
    }} animate={{
      y: 0
    }} exit={{
      y: -100
    }} className="fixed top-0 left-0 right-0 z-[100] bg-white/80 backdrop-blur-md border-b border-[#2F5233]/10 py-3 px-6 shadow-lg flex items-center justify-between" data-id="element-33">
          <div className="flex items-center gap-2" data-id="element-34">
            <div className="w-8 h-8 bg-[#2F5233] rounded-full flex items-center justify-center" data-id="element-35">
              <Heart className="w-4 h-4 text-white fill-white" data-id="element-36" />
            </div>
            <span className="font-bold text-[#2F5233] hidden sm:block" data-id="element-37">
              Alma Textil
            </span>
          </div>

          <div className="absolute left-1/2 -translate-x-1/2" data-id="element-38">
            <CountdownTimer data-id="element-39" />
          </div>

          <div className="flex items-center gap-4" data-id="element-40">
            <button onClick={onAction} className="bg-[#E07A5F] text-white px-6 py-2.5 rounded-full font-black uppercase shadow-md hover:bg-[#D1694E] transition-all active:scale-95 mr-[-20px] text-[12px]" data-id="element-41">
              VER OFERTA
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
};
const ScrollReveal = ({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 40
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 1.2,
  delay,
  ease: [0.21, 0.47, 0.32, 0.98]
}} data-id="element-42">
    {children}
  </motion.div>;
const CommentSection = () => {
  const AVATAR_COLORS = ['from-[#2F5233] to-[#4A7856]', 'from-[#E07A5F] to-[#D1694E]', 'from-[#9FD9D3] to-[#6BC4B8]', 'from-[#8D7B6D] to-[#A69484]', 'from-[#D4AF37] to-[#C49B2A]', 'from-[#B56576] to-[#9E4F5E]', 'from-[#6D597A] to-[#5B4868]', 'from-[#355070] to-[#2A4059]'];
  const AVATAR_EMOJIS = ['🧶', '🪡', '🧵', '🌸', '🌿', '💐', '🎀', '🦋', '🌻', '🐰', '🧸', '✨', '💜', '🌺', '🍀', '🎨', '🪻', '🐱', '🌷', '🫧'];
  const [comments, setComments] = useState([{
    id: 1,
    user: 'Norma Beatriz',
    avatar: 'NB',
    emoji: '🧶',
    colorIdx: 0,
    date: 'hace 2 horas',
    rating: 5,
    text: 'Increíble la calidad de los gráficos. Por fin entiendo cómo cerrar bien los puntos. ¡Muy recomendado!',
    likes: 24,
    isLiked: false
  }, {
    id: 2,
    user: 'Graciela M.',
    avatar: 'GM',
    emoji: '🪡',
    colorIdx: 1,
    date: 'hace 4 horas',
    rating: 5,
    text: 'Los amigurumis son un sueño. Ya terminé mi primer muñeco para mi nieta y quedó precioso.',
    likes: 18,
    isLiked: false
  }, {
    id: 3,
    user: 'Marta Silvia',
    avatar: 'MS',
    emoji: '🌸',
    colorIdx: 2,
    date: 'hace 5 horas',
    rating: 4,
    text: 'Muy completo todo. Me gustaría que suban más de ropa de invierno, pero el set de bebé es precioso.',
    likes: 12,
    isLiked: false
  }, {
    id: 4,
    user: 'Elena R.',
    avatar: 'ER',
    emoji: '🧵',
    colorIdx: 3,
    date: 'hace 1 día',
    rating: 5,
    text: 'Los patrones son muy claros, valió la pena la inversión. Ya estoy empezando el tercer proyecto.',
    likes: 9,
    isLiked: false
  }, {
    id: 5,
    user: 'Patricia G.',
    avatar: 'PG',
    emoji: '🌿',
    colorIdx: 4,
    date: 'hace 1 día',
    rating: 5,
    text: 'Excelente atención y los archivos llegan al toque. Los diseños son muy originales.',
    likes: 15,
    isLiked: false
  }, {
    id: 6,
    user: 'Rosa Inés',
    avatar: 'RI',
    emoji: '💐',
    colorIdx: 5,
    date: 'hace 2 días',
    rating: 4,
    text: 'Me encantaron los bonos, especialmente el de las flores. Muy bien explicado todo.',
    likes: 7,
    isLiked: false
  }, {
    id: 7,
    user: 'Mirta Beatriz',
    avatar: 'MB',
    emoji: '🎀',
    colorIdx: 6,
    date: 'hace 2 días',
    rating: 5,
    text: 'Por fin encontré patrones que se entienden de verdad. ¡Gracias por compartir su talento!',
    likes: 21,
    isLiked: false
  }, {
    id: 8,
    user: 'Alicia S.',
    avatar: 'AS',
    emoji: '🦋',
    colorIdx: 7,
    date: 'hace 3 días',
    rating: 5,
    text: 'El grupo de apoyo es genial. Siempre hay alguien para sacarte las dudas.',
    likes: 11,
    isLiked: false
  }, {
    id: 9,
    user: 'Susana T.',
    avatar: 'ST',
    emoji: '🌻',
    colorIdx: 0,
    date: 'hace 3 días',
    rating: 5,
    text: 'La biblioteca es inmensa, hay para todos los gustos. Muy conforme con la compra.',
    likes: 14,
    isLiked: false
  }, {
    id: 10,
    user: 'Gladys R.',
    avatar: 'GR',
    emoji: '🐰',
    colorIdx: 1,
    date: 'hace 4 días',
    rating: 5,
    text: 'Ya hice tres mantas para regalar. Los puntos fantasía son hermosos.',
    likes: 19,
    isLiked: false
  }, {
    id: 11,
    user: 'Juana P.',
    avatar: 'JP',
    emoji: '🧸',
    colorIdx: 2,
    date: 'hace 4 días',
    rating: 4,
    text: 'Muy buenos los videos explicativos que vienen de regalo. Ayudan mucho.',
    likes: 8,
    isLiked: false
  }, {
    id: 12,
    user: 'Beatriz L.',
    avatar: 'BL',
    emoji: '✨',
    colorIdx: 3,
    date: 'hace 5 días',
    rating: 5,
    text: 'Es la mejor inversión que hice este año para mi hobby. ¡Sigan así!',
    likes: 25,
    isLiked: false
  }, {
    id: 13,
    user: 'Silvia N.',
    avatar: 'SN',
    emoji: '💜',
    colorIdx: 4,
    date: 'hace 5 días',
    rating: 5,
    text: 'Los patrones de ropa son tendencia total. Me hice un cárdigan que todos me elogian.',
    likes: 16,
    isLiked: false
  }, {
    id: 14,
    user: 'Margarita F.',
    avatar: 'MF',
    emoji: '🌺',
    colorIdx: 5,
    date: 'hace 6 días',
    rating: 5,
    text: 'Todo perfecto, desde el pago hasta la descarga. Muy profesionales.',
    likes: 13,
    isLiked: false
  }, {
    id: 15,
    user: 'Cristina D.',
    avatar: 'CD',
    emoji: '🍀',
    colorIdx: 6,
    date: 'hace 6 días',
    rating: 5,
    text: 'Me encanta que los patrones vengan con gráficos claros. Facilita mucho el trabajo.',
    likes: 17,
    isLiked: false
  }, {
    id: 16,
    user: 'Zulma T.',
    avatar: 'ZT',
    emoji: '🎨',
    colorIdx: 7,
    date: 'hace 1 semana',
    rating: 4,
    text: 'Muy lindo todo. El set de cocina es lo más vendido en mi emprendimiento.',
    likes: 10,
    isLiked: false
  }, {
    id: 17,
    user: 'Olga B.',
    avatar: 'OB',
    emoji: '🪻',
    colorIdx: 0,
    date: 'hace 1 semana',
    rating: 5,
    text: 'Gracias por los consejos para principiantes. Me ayudaron a perder el miedo.',
    likes: 22,
    isLiked: false
  }, {
    id: 18,
    user: 'Nélida G.',
    avatar: 'NG',
    emoji: '🐱',
    colorIdx: 1,
    date: 'hace 1 semana',
    rating: 5,
    text: 'Los amigurumis de animales son los más tiernos que vi. ¡Mis nietos están felices!',
    likes: 20,
    isLiked: false
  }, {
    id: 19,
    user: 'Inés S.',
    avatar: 'IS',
    emoji: '🌷',
    colorIdx: 2,
    date: 'hace 2 semanas',
    rating: 5,
    text: 'Excelente material. Se nota que hay mucho trabajo detrás de cada patrón.',
    likes: 18,
    isLiked: false
  }, {
    id: 20,
    user: 'Raquel M.',
    avatar: 'RM',
    emoji: '🫧',
    colorIdx: 3,
    date: 'hace 2 semanas',
    rating: 5,
    text: 'Súper completo. No me canso de descubrir nuevos proyectos para hacer.',
    likes: 23,
    isLiked: false
  }]);
  const [newComment, setNewComment] = useState('');
  const [rating, setRating] = useState(5);
  const [showThanks, setShowThanks] = useState(false);
  const [visibleCount, setVisibleCount] = useState(3);
  const handlePublish = () => {
    if (!newComment.trim()) return;
    const randomIdx = Math.floor(Math.random() * AVATAR_EMOJIS.length);
    const comment = {
      id: Date.now(),
      user: 'Usuario',
      avatar: 'U',
      emoji: AVATAR_EMOJIS[randomIdx],
      colorIdx: randomIdx % AVATAR_COLORS.length,
      date: 'ahora mismo',
      rating,
      text: newComment,
      likes: 0,
      isLiked: false
    };
    setComments([comment, ...comments]);
    setNewComment('');
    setRating(5);
    setShowThanks(true);
  };
  const toggleLike = (id: number) => {
    setComments(comments.map(c => {
      if (c.id === id) {
        return {
          ...c,
          isLiked: !c.isLiked,
          likes: c.isLiked ? c.likes - 1 : c.likes + 1
        };
      }
      return c;
    }));
  };
  return <ScrollReveal data-id="element-43">
      <div className="max-w-4xl mx-auto p-8 bg-white/40 backdrop-blur-sm rounded-[3rem] border border-[#2F5233]/10 shadow-sm pt-[32px] pb-[32px] mt-[40px] space-y-[24px]" data-id="element-44">
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-10 gap-4" data-id="element-45">
          <h3 className="text-3xl font-bold flex items-center gap-3 text-[#2F5233] font-serif" data-id="element-46">
            <MessageCircle className="text-[#E07A5F] w-8 h-8" data-id="element-47" /> Comunidad y
            Feedback
          </h3>
          <div className="flex items-center gap-2 bg-[#2F5233]/5 px-4 py-2 rounded-full border border-[#2F5233]/10" data-id="element-48">
            <div className="flex gap-0.5" data-id="element-49">
              {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 fill-[#E07A5F] text-[#E07A5F]" data-id="element-50" />)}
            </div>
            <span className="text-sm font-bold text-[#2F5233]" data-id="element-51">
              4.9/5 Promedio
            </span>
          </div>
        </div>

        <div className="mb-12 space-y-6 bg-white/60 p-8 rounded-[2.5rem] border border-[#2F5233]/5 shadow-inner" data-id="element-52">
          <div className="flex flex-col gap-4" data-id="element-53">
            <p className="text-sm font-bold text-[#8D7B6D] uppercase tracking-wider" data-id="element-54">
              Tu Calificación:
            </p>
            <div className="flex gap-2" data-id="element-55">
              {[1, 2, 3, 4, 5].map(s => <motion.button key={s} whileHover={{
              scale: 1.2
            }} whileTap={{
              scale: 0.9
            }} onClick={() => setRating(s)} data-id="element-56">
                  <Star className={`w-8 h-8 transition-colors ${s <= rating ? 'fill-[#E07A5F] text-[#E07A5F]' : 'text-[#E07A5F]/20'}`} data-id="element-57" />
                </motion.button>)}
            </div>
          </div>

          <textarea value={newComment} onChange={e => setNewComment(e.target.value)} placeholder="Compartí tu experiencia con la comunidad..." className="w-full bg-white border border-[#2F5233]/10 rounded-2xl p-5 text-[#4A3F35] focus:ring-2 focus:ring-[#2F5233]/20 outline-none transition-all shadow-sm min-h-[120px]" data-id="element-58" />

          <div className="flex flex-wrap items-center justify-end gap-4" data-id="element-59">
            <button onClick={handlePublish} disabled={!newComment.trim()} className="bg-[#2F5233] text-white font-black py-4 px-10 rounded-2xl hover:bg-[#1F3A22] transition-all shadow-lg disabled:opacity-50 disabled:cursor-not-allowed active:scale-95" data-id="element-60">
              Publicar Comentario
            </button>
          </div>
        </div>

        <div className="space-y-4" data-id="element-61">
          <AnimatePresence mode="popLayout" data-id="element-62">
            {comments.slice(0, visibleCount).map(c => <motion.div key={c.id} layout initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            scale: 0.95
          }} className="bg-white/40 p-4 rounded-2xl border border-[#2F5233]/5 hover:border-[#2F5233]/10 transition-all group" data-id="element-63">
                <div className="flex gap-4" data-id="element-64">
                  <div className={`w-12 h-12 shrink-0 rounded-full flex items-center justify-center shadow-sm border border-white/50 bg-gradient-to-br ${AVATAR_COLORS[c.colorIdx % AVATAR_COLORS.length]}`} data-id="element-65">
                    <span className="text-xl" data-id="element-66">{c.emoji}</span>
                  </div>
                  <div className="flex-1 flex flex-col" data-id="element-67">
                    <div className="flex items-center justify-between mb-2" data-id="element-68">
                      <div className="flex items-center gap-2" data-id="element-69">
                        <div data-id="element-70">
                          <p className="font-bold text-[#2F5233] leading-none text-sm mb-1" data-id="element-71">
                            {c.user}
                          </p>
                          <div className="flex items-center gap-2" data-id="element-72">
                            <div className="flex gap-0.5" data-id="element-73">
                              {Array.from({
                            length: 5
                          }).map((_, i) => <Star key={i} className={`w-2.5 h-2.5 ${i < c.rating ? 'fill-[#E07A5F] text-[#E07A5F]' : 'text-[#E07A5F]/20'}`} data-id="element-74" />)}
                            </div>
                            <span className="text-[9px] text-[#8D7B6D] font-medium" data-id="element-75">
                              • {c.date}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="bg-[#2F5233]/5 px-2 py-0.5 rounded-full flex items-center gap-1" data-id="element-76">
                        <CheckCircle2 className="w-2.5 h-2.5 text-[#2F5233]" data-id="element-77" />
                        <span className="text-[8px] font-bold text-[#2F5233] uppercase" data-id="element-78">
                          Verificada
                        </span>
                      </div>
                    </div>
                    <p className="text-[#4A3F35] text-sm leading-relaxed mb-3 flex-1 italic" data-id="element-79">
                      "{c.text}"
                    </p>
                    <div className="flex items-center justify-between pt-2 border-t border-[#2F5233]/5" data-id="element-80">
                      <button onClick={() => toggleLike(c.id)} className={`flex items-center gap-1.5 px-3 py-1 rounded-full transition-all font-bold text-[11px] ${c.isLiked ? 'bg-[#E07A5F]/10 text-[#E07A5F]' : 'text-[#8D7B6D] hover:bg-[#2F5233]/5'}`} data-id="element-81">
                        <Heart className={`w-3.5 h-3.5 transition-all ${c.isLiked ? 'fill-[#E07A5F]' : ''}`} data-id="element-82" />
                        {c.likes}
                      </button>
                      <button className="text-[10px] font-bold text-[#2F5233]/40 hover:text-[#2F5233] transition-colors" data-id="element-83">
                        Responder
                      </button>
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </AnimatePresence>
        </div>

        {visibleCount < comments.length && <button onClick={() => setVisibleCount(prev => prev + 3)} className="w-full mt-10 py-5 border-2 border-dashed border-[#2F5233]/10 rounded-[2rem] font-black text-[#2F5233] hover:bg-[#2F5233]/5 hover:border-[#2F5233]/20 transition-all uppercase tracking-widest text-sm" data-id="element-84">
            Ver más testimonios de la comunidad
          </button>}

        {showThanks && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/20 backdrop-blur-md p-4" data-id="element-85">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} className="bg-white text-[#4A3F35] p-10 rounded-[3rem] max-w-sm text-center shadow-2xl border border-[#2F5233]/10" data-id="element-86">
              <div className="bg-[#2F5233]/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-87">
                <CheckCircle2 className="text-[#2F5233] w-12 h-12" data-id="element-88" />
              </div>
              <h4 className="text-2xl font-bold mb-3 text-[#2F5233] font-serif" data-id="element-89">
                ¡Gracias por inspirarnos!
              </h4>
              <p className="text-[#8D7B6D] mb-8 leading-relaxed" data-id="element-90">
                Tu proyecto y tu opinión son el motor de esta comunidad.
              </p>
              <button onClick={() => setShowThanks(false)} className="w-full bg-[#2F5233] text-white py-4 rounded-2xl font-black shadow-lg hover:bg-[#1F3A22] transition-colors uppercase tracking-wider" data-id="element-91">
                Cerrar
              </button>
            </motion.div>
          </div>}
      </div>
    </ScrollReveal>;
};
const ProjectCarousel = () => {
  return <div className="w-full overflow-hidden py-12 bg-white/20 backdrop-blur-sm rounded-[3rem] border border-[#2F5233]/10" data-id="element-92">
      <div className="text-center mb-10" data-id="element-93">
        <h3 className="text-3xl font-bold text-[#2F5233] font-serif" data-id="element-94">
          Proyectos Terminados por la Comunidad
        </h3>
        <p className="text-[#8D7B6D]" data-id="element-95">
          Inspirate con lo que vos también vas a lograr
        </p>
      </div>

      <div className="flex relative" data-id="element-96">
        <motion.div className="flex gap-6 px-6" animate={{
        x: [0, -2500]
      }} transition={{
        duration: 40,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-97">
          {[...PROJECTS, ...PROJECTS].map((project, idx) => <div key={idx} className="min-w-[300px] bg-white/60 backdrop-blur-sm rounded-3xl overflow-hidden shadow-md border border-[#2F5233]/5 group" data-id="element-98">
              <div className="h-64 overflow-hidden" data-id="element-99">
                <img src={project.url} alt={project.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-100" />
              </div>
              <div className="p-6" data-id="element-101">
                <h4 className="font-bold text-[#2F5233] mb-2" data-id="element-102">
                  {project.title}
                </h4>
                <p className="text-sm text-[#8D7B6D] italic" data-id="element-103">
                  "{project.comment}"
                </p>
              </div>
            </div>)}
        </motion.div>
      </div>
    </div>;
};
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-[#2F5233]/10 last:border-0" data-id="element-104">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left gap-4 group" data-id="element-105">
        <div className="flex items-center gap-4" data-id="element-106">
          <div className="w-10 h-10 rounded-full bg-[#2F5233]/5 flex items-center justify-center shrink-0 group-hover:bg-[#2F5233]/10 transition-colors" data-id="element-107">
            <HelpCircle className="w-5 h-5 text-[#E07A5F]" data-id="element-108" />
          </div>
          <span className="text-lg font-bold text-[#2F5233] font-serif" data-id="element-109">
            {question}
          </span>
        </div>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-110">
          <ChevronDown className="w-6 h-6 text-[#8D7B6D] mb-[80px]" data-id="element-111" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-112">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-113">
            <p className="pb-6 pl-14 text-[#8D7B6D] leading-relaxed" data-id="element-114">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
const FAQSection = () => {
  const faqs = [{
    question: '¿Cómo recibo el acceso a Alma Textil?',
    answer: 'El acceso es inmediato y digital. Una vez confirmado tu pago, recibirás un correo electrónico con tus credenciales para ingresar a la plataforma donde encontrarás todas las clases, moldes y bonos. Podrás verlos desde tu celular, tablet o computadora.'
  }, {
    question: '¿Por cuánto tiempo tendré acceso al contenido?',
    answer: '¡El acceso es de por vida! Una vez que te unes a la academia, el contenido es tuyo para siempre. Podrás avanzar a tu propio ritmo, repetir las clases las veces que necesites y descargar los moldes cuando quieras.'
  }, {
    question: '¿Necesito tener conocimientos previos de costura?',
    answer: 'Para nada. Alma Textil está diseñado especialmente para guiarte desde cero absoluto. Te enseñaremos desde cómo enhebrar la máquina hasta cómo confeccionar prendas completas, paso a paso y sin prisas.'
  }, {
    question: '¿Los moldes vienen en diferentes tallas?',
    answer: '¡Sí! El Bono de Atelier de Creación incluye más de 2000 moldes profesionales escalados en diferentes tallas, listos para imprimir en casa y comenzar a cortar tus telas con total seguridad.'
  }, {
    question: '¿Me sirve si quiero empezar a vender lo que coso?',
    answer: 'Absolutamente. No solo aprenderás a coser con acabados profesionales, sino que el bono "Tu Marca Textil" te dará las herramientas de branding y presentación necesarias para que puedas lanzar tu propio emprendimiento desde casa.'
  }];
  return <ScrollReveal data-id="element-115">
      <section className="max-w-3xl mx-auto px-6 mt-[0px] mb-[0px]" data-id="element-116">
        <div className="text-center mb-12" data-id="element-117">
          <h2 className="text-4xl font-bold text-[#2F5233] font-serif mb-4" data-id="element-118">
            Preguntas Frecuentes
          </h2>
          <p className="text-[#8D7B6D]" data-id="element-119">
            Todo lo que necesitas saber sobre Alma Textil
          </p>
        </div>
        <div className="bg-white/40 backdrop-blur-md rounded-[2.5rem] p-8 border border-[#2F5233]/10 shadow-sm" data-id="element-120">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-121" />)}
        </div>
      </section>
    </ScrollReveal>;
};
const FloatingBackground = () => {
  const elements = [{
    icon: Scissors,
    size: 24,
    color: '#D4AF37',
    blur: 'blur-[1px]'
  }, {
    icon: Ruler,
    size: 20,
    color: '#8D7B6D',
    blur: 'blur-[2px]'
  }, {
    icon: Wind,
    size: 28,
    color: '#E07A5F',
    blur: 'blur-[0px]'
  }, {
    icon: Flower2,
    size: 32,
    color: '#FADADD',
    blur: 'blur-[3px]'
  }, {
    icon: Circle,
    size: 12,
    color: '#D4AF37',
    blur: 'blur-[1px]'
  }, {
    icon: Scissors,
    size: 18,
    color: '#8D7B6D',
    blur: 'blur-[4px]'
  }, {
    icon: Wind,
    size: 22,
    color: '#FADADD',
    blur: 'blur-[1px]'
  }, {
    icon: Flower2,
    size: 24,
    color: '#E07A5F',
    blur: 'blur-[2px]'
  }, {
    icon: Ruler,
    size: 16,
    color: '#D4AF37',
    blur: 'blur-[0px]'
  }, {
    icon: Circle,
    size: 10,
    color: '#8D7B6D',
    blur: 'blur-[2px]'
  }];
  return <div className="fixed inset-0 pointer-events-none overflow-hidden z-0" data-id="element-122">
      {elements.map((el, i) => <motion.div key={i} className={`absolute ${el.blur} opacity-[0.15]`} initial={{
      x: Math.random() * 100 + '%',
      y: Math.random() * 100 + '%',
      rotate: Math.random() * 360
    }} animate={{
      x: [Math.random() * 100 + '%', Math.random() * 100 + '%', Math.random() * 100 + '%'],
      y: [Math.random() * 100 + '%', Math.random() * 100 + '%', Math.random() * 100 + '%'],
      rotate: [0, 180, 360]
    }} transition={{
      duration: 40 + Math.random() * 40,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-123">
          <el.icon size={el.size} strokeWidth={1} color={el.color} data-id="element-124" />
        </motion.div>)}
    </div>;
};
const App = () => {
  useEffect(() => {
    const pixelId = '1293858232676625';
    // Inject Meta Pixel script directly
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      if(s&&s.parentNode){s.parentNode.insertBefore(t,s)}
      else{b.head.appendChild(t)}}
      (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  const [showExitIntent, setShowExitIntent] = useState(false);
  const [spots, setSpots] = useState(13);
  const [viewers, setViewers] = useState(48);
  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(prev => {
        const change = Math.floor(Math.random() * 5) - 2;
        const next = prev + change;
        return next < 30 ? 33 : next > 60 ? 58 : next;
      });
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setSpots(prev => prev > 3 ? prev - 1 : prev);
    }, 45000);
    return () => clearInterval(interval);
  }, []);
  const [titleVisible, setTitleVisible] = useState(true);
  useEffect(() => {
    const titleInterval = setInterval(() => {
      setTitleVisible(false);
      setTimeout(() => setTitleVisible(true), 4000);
    }, 14000);
    return () => clearInterval(titleInterval);
  }, []);
  const today = new Date().toLocaleDateString('es-AR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  const scrollToPurchase = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handlePurchase = () => {
    window.location.href = CHECKOUT_LINK;
  };
  const [showHookButton, setShowHookButton] = useState(true);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    // Show button when in the top part of the page (hook area)
    if (latest < 800) {
      setShowHookButton(true);
    } else {
      setShowHookButton(false);
    }
  });
  return <div className="min-h-screen selection:bg-[#2F5233]/20 selection:text-[#2F5233] relative" data-id="element-125">
      <FloatingBackground data-id="element-126" />
      <StickyHeader onAction={scrollToPurchase} data-id="element-127" />
      <PurchasePopup data-id="element-128" />

      {/* Header Banner */}
      <div className="text-white py-1.5 text-center font-bold px-4 shadow-sm relative z-50 bg-gradient-to-r from-[#9FD9D3]/90 via-[#82c9c1]/90 to-[#9FD9D3]/90 backdrop-blur-sm flex items-center justify-center gap-4" data-id="element-129">
        <div className="flex items-center gap-2" data-id="element-130">
          <Calendar className="w-3.5 h-3.5 text-[#2F5233]" data-id="element-131" />
          <span className="text-[#2F5233] uppercase tracking-wider text-[10px]" data-id="element-132">
            OFERTA VÁLIDA SOLO HOY: {today}
          </span>
        </div>
        <div className="h-3 w-px bg-[#2F5233]/20 hidden sm:block" data-id="element-133" />
        <CountdownTimer data-id="element-134" />
      </div>

      {/* Hook Image Section */}
      <ScrollReveal data-id="element-135">
        <section className="w-full flex flex-col items-center relative" data-id="element-136">
          <div className="w-full overflow-hidden flex flex-col leading-[0] text-[0]" data-id="element-137">
            <div className="relative w-full" data-id="element-138">
              <img src="https://cdn.magicpatterns.com/uploads/1HFY2cRUWeNHvCHea5nC5S/ChatGPT_Image_27_may_2026,_19_22_47.webp" alt="Alma Textil" className="w-full h-auto block m-0 p-0" data-id="element-139" />
              <div className="absolute bottom-[22%] left-[50%] -translate-x-1/2 md:left-[68.5%] md:translate-x-0 w-[85%] md:w-[38.5%] flex justify-center" data-id="element-140">
                <PremiumCTAButton onClick={scrollToPurchase} className="w-full" data-id="element-141" />
              </div>
            </div>
            {/* New Emotional Sewing Section Image - Seamlessly connected */}
            <img src="https://cdn.magicpatterns.com/uploads/qumkRHwjXfh3cQuU4LfZ5u/ChatGPT_Image_27_may_2026,_20_12_00.png" alt="Querida amante de la costura" className="w-full h-auto block m-0 p-0" data-id="element-142" />
          </div>
        </section>
      </ScrollReveal>

      <main className="max-w-5xl mx-auto px-6 py-12 pt-[00px] pb-[00px] pl-[0px] pr-[0px] space-y-[22px]" data-id="element-143">
        {/* CTA Button - Moved below emotional section */}
        <ScrollReveal data-id="element-144">
          <div className="my-16 text-center" data-id="element-145"></div>
        </ScrollReveal>

        <ScrollReveal data-id="element-146">
          <div className="space-y-12" data-id="element-147">
            <h3 className="md:text-5xl font-bold text-[#2F5233] text-center font-serif text-[28px]" data-id="element-148">
              QUÉ VAS A LOGRAR EN ALMA TEXTIL
            </h3>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-149">
              {[{
              title: 'Costura desde cero absoluto',
              desc: 'Aunque nunca hayas enhebrado una aguja, aprenderás las bases reales de la costura. Pierde el miedo a la máquina y avanza con seguridad, paso a paso, en un ambiente de aprendizaje tranquilo y femenino.',
              img: 'https://cdn.magicpatterns.com/uploads/ahM5BtGe6dC6grFtfuxkZk/ChatGPT_Image_27_may_2026,_20_24_22.webp'
            }, {
              title: 'Moldes profesionales sin frustración',
              desc: 'Deja de pelear con tutoriales confusos. Aprenderás a interpretar moldes, cortar la tela correctamente y ensamblar piezas con precisión para que tu ropa calce perfecto desde el primer intento.',
              img: 'https://cdn.magicpatterns.com/uploads/3SY6P7dDZ92qd3U1HZqcW7/ChatGPT_Image_27_may_2026,_20_27_32.webp'
            }, {
              title: 'Crea tu propia ropa y proyectos',
              desc: 'Transforma telas en prendas hermosas, accesorios y decoración para el hogar. Construye algo con tus propias manos, recupera tu libertad creativa y siéntete orgullosa de decir "lo hice yo".',
              img: 'https://cdn.magicpatterns.com/uploads/ow5X8Hwx5Vnkg69K5fRTii/ChatGPT_Image_27_may_2026,_20_28_45.webp'
            }, {
              title: 'Inicia tu emprendimiento desde casa',
              desc: 'Convierte tu pasión en ingresos. Te guiaremos no solo en la técnica, sino en cómo crear tu marca, presentar tus productos y construir un negocio textil que te brinde independencia financiera.',
              img: 'https://cdn.magicpatterns.com/uploads/a54aFKpz1MoJHLk1nRSbQM/ChatGPT_Image_27_may_2026,_20_30_54.webp'
            }].map((item, idx) => <motion.div key={idx} whileHover={{
              y: -10
            }} className="bg-white/30 backdrop-blur-md rounded-[3rem] border border-[#2F5233]/10 shadow-sm overflow-hidden flex flex-col" data-id="element-150">
                  <div className="p-4" data-id="element-151">
                    <img src={item.img} alt={item.title} className="w-full h-auto rounded-[2rem] shadow-md" data-id="element-152" />
                  </div>
                  <div className="p-8 pt-4 space-y-4" data-id="element-153">
                    <h4 className="text-2xl font-bold text-[#2F5233] font-serif leading-tight" data-id="element-154">
                      {item.title}
                    </h4>
                    <p className="text-[#4A3F35] leading-relaxed" data-id="element-155">
                      {item.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </ScrollReveal>

        {/* Project Carousel */}
        <ScrollReveal data-id="element-156">
          <ProjectCarousel data-id="element-157" />
        </ScrollReveal>

        {/* Bonuses Section */}
        <section className="mt-32" data-id="element-158">
          <ScrollReveal data-id="element-159">
            <div className="text-center mb-16" data-id="element-160">
              <h3 className="text-4xl md:text-6xl font-black mb-6 text-[#2F5233] pt-[22px] pb-[22px]" data-id="element-161">
                Y SI TE UNÍS AHORA, RECIBÍS ESTOS{' '}
                <span className="text-[#E07A5F]" data-id="element-162">4 BONOS EXCLUSIVOS</span>:
              </h3>
              <p className="text-[#E07A5F] font-bold text-2xl animate-pulse" data-id="element-163">
                ¡GRATIS SOLO POR EL DÍA DE HOY!
              </p>
            </div>
          </ScrollReveal>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-164">
            {BONUSES.map((bonus, idx) => <ScrollReveal key={bonus.id} delay={idx * 0.1} data-id="element-165">
                <div className="bg-white/40 backdrop-blur-md rounded-[3rem] overflow-hidden border border-[#2F5233]/10 hover:border-[#2F5233]/30 transition-all group cursor-pointer shadow-sm hover:shadow-xl" onClick={handlePurchase} data-id="element-166">
                  <div className="aspect-[4/3] overflow-hidden p-4" data-id="element-167">
                    <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover rounded-[2rem] border-4 border-white shadow-md group-hover:scale-105 transition-transform duration-1000 pl-[15px] pr-[15px]" data-id="element-168" />
                  </div>
                  <div className="p-8 pt-2" data-id="element-169">
                    <h4 className="text-xl font-bold mb-3 text-[#2F5233] font-serif" data-id="element-170">
                      {bonus.title}
                    </h4>
                    <p className="text-[#8D7B6D] text-base leading-relaxed mb-6" data-id="element-171">
                      {bonus.desc}
                    </p>
                    <div className="flex items-center justify-between pt-6 border-t border-[#2F5233]/5" data-id="element-172">
                      <span className="text-sm font-bold text-[#8D7B6D] line-through" data-id="element-173">
                        VALOR: $7.998 PESOS
                      </span>
                      <span className="text-xl font-bold text-[#E07A5F]" data-id="element-174">
                        HOY GRATIS
                      </span>
                    </div>
                  </div>
                </div>
              </ScrollReveal>)}
          </div>
        </section>

        {/* Summary Section: What you get */}
        <ScrollReveal data-id="element-175">
          <section className="mt-32 mb-20" data-id="element-176">
            <div className="bg-white/30 backdrop-blur-lg rounded-[4rem] p-8 md:p-16 border border-[#2F5233]/10 shadow-sm text-center" data-id="element-177">
              <h3 className="text-4xl md:text-5xl font-bold text-[#2F5233] font-serif mb-8" data-id="element-178">
                Tu Academia Textil Completa
              </h3>
              <p className="text-xl text-[#8D7B6D] mb-12 max-w-2xl mx-auto" data-id="element-179">
                Esto es todo lo que vas a recibir hoy al unirte a nuestra
                comunidad. Un ecosistema diseñado para transformar tu pasión en
                arte y libertad.
              </p>
              <div className="relative group" data-id="element-180">
                <div className="absolute -inset-4 bg-gradient-to-r from-[#E07A5F]/10 via-[#2F5233]/5 to-[#E07A5F]/10 rounded-[3rem] blur-2xl opacity-50 group-hover:opacity-100 transition-opacity duration-1000" data-id="element-181" />
                <img src="https://cdn.magicpatterns.com/uploads/1tWr4LV3AWhb34qEsJTy87/ChatGPT_Image_27_may_2026,_21_50_55.webp" alt="Colección Completa Alma Textil" className="relative w-full max-w-4xl mx-auto rounded-[2.5rem] shadow-2xl border-8 border-white" data-id="element-182" />
              </div>
              <div className="mt-12 flex flex-wrap justify-center gap-6" data-id="element-183">
                <div className="flex items-center gap-2 text-[#2F5233] font-bold" data-id="element-184">
                  <CheckCircle2 className="w-5 h-5 text-[#E07A5F]" data-id="element-185" />
                  <span data-id="element-186">Programa Principal de Costura</span>
                </div>
                <div className="flex items-center gap-2 text-[#2F5233] font-bold" data-id="element-187">
                  <CheckCircle2 className="w-5 h-5 text-[#E07A5F]" data-id="element-188" />
                  <span data-id="element-189">4 Bonos Exclusivos</span>
                </div>
                <div className="flex items-center gap-2 text-[#2F5233] font-bold" data-id="element-190">
                  <CheckCircle2 className="w-5 h-5 text-[#E07A5F]" data-id="element-191" />
                  <span data-id="element-192">Acceso de por Vida</span>
                </div>
                <div className="flex items-center gap-2 text-[#2F5233] font-bold" data-id="element-193">
                  <CheckCircle2 className="w-5 h-5 text-[#E07A5F]" data-id="element-194" />
                  <span data-id="element-195">Soporte y Comunidad</span>
                </div>
              </div>
            </div>
          </section>
        </ScrollReveal>

        {/* Pricing Section */}
        <ScrollReveal data-id="element-196">
          <section id="pricing" className="text-center py-24 bg-white/50 backdrop-blur-xl rounded-[4rem] border border-[#2F5233]/10 shadow-2xl overflow-hidden relative pt-[0px] pb-[0px] pl-[2px] pr-[2px] mt-[40px] mb-[40px] space-y-[4px]" data-id="element-197">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#E07A5F]/5 rounded-full -mr-32 -mt-32 blur-3xl" data-id="element-198" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#2F5233]/5 rounded-full -ml-32 -mb-32 blur-3xl" data-id="element-199" />

            <div className="bg-[#2F5233]/5 border-b border-[#2F5233]/10 py-4 flex flex-wrap items-center justify-center gap-8 px-6" data-id="element-200">
              <div className="flex items-center gap-3" data-id="element-201">
                <div className="relative" data-id="element-202">
                  <div className="w-3 h-3 bg-red-500 rounded-full animate-ping absolute inset-0" data-id="element-203" />
                  <div className="w-3 h-3 bg-red-500 rounded-full relative" data-id="element-204" />
                </div>
                <div className="text-left" data-id="element-205">
                  <p className="text-sm font-bold text-[#2F5233]" data-id="element-206">
                    <span className="text-[#E07A5F]" data-id="element-207">{viewers} personas</span>{' '}
                    mirando esta oferta ahora
                  </p>
                </div>
              </div>

              <div className="h-8 w-px bg-[#2F5233]/10 hidden md:block" data-id="element-208" />

              <div className="flex items-center gap-3" data-id="element-209">
                <Users className="w-5 h-5 text-[#2F5233]" data-id="element-210" />
                <div className="text-left" data-id="element-211">
                  <p className="text-sm font-bold text-[#2F5233]" data-id="element-212">
                    Quedan solo{' '}
                    <span className="text-[#E07A5F]" data-id="element-213">{spots} cupos</span> con
                    este descuento
                  </p>
                </div>
              </div>
            </div>

            <h3 className="md:text-5xl font-bold text-[#2F5233] font-serif text-[20px] pl-[20px] pr-[20px] mt-[1px] mb-[1px] pt-[30px] pb-[30px]" data-id="element-214">
              INVERTÍ EN TU TALENTO HOY
            </h3>
            <div className="mt-[20px] mb-[20px] pb-[22px]" data-id="element-215">
              <p className="text-[#8D7B6D] line-through text-3xl mb-4" data-id="element-216">
                Antes $39.990 pesos
              </p>
              <div className="flex flex-col items-center justify-center gap-2" data-id="element-217">
                <p className="md:text-[10rem] font-black tracking-tighter text-[48px] text-[#1DB343] leading-none" data-id="element-218">
                  $19.990 ARS
                </p>
                <div className="bg-[#E07A5F] text-white px-4 py-1 rounded-full text-xl font-black animate-bounce shadow-lg" data-id="element-219">
                  50% OFF
                </div>
              </div>

              <div className="inline-flex bg-[#2F5233]/5 text-[#2F5233] px-10 py-5 rounded-full font-bold border border-[#2F5233]/10 pl-[10px] pr-[10px] pt-[0px] pb-[0px] ml-[20px] mr-[20px] gap-[0px] items-center justify-start mt-8" data-id="element-220">
                <CreditCard className="w-7 h-7 text-[#E07A5F] bg-[#FFFFFF]" data-id="element-221" />
                <span className="text-xl text-[#007517]" data-id="element-222">
                  Hasta 3 cuotas sin interés
                </span>
              </div>
            </div>

            <CTAButton onClick={handlePurchase} data-id="element-223" />

            {/* Redesigned Payment Logos Section */}
            <div className="max-w-2xl mx-auto mb-10 space-y-6" data-id="element-224">
              <p className="text-[10px] font-bold text-[#8D7B6D] uppercase tracking-widest" data-id="element-225">
                MEDIOS DE PAGO PROCESADOS
              </p>

              <div className="flex flex-wrap justify-center items-center gap-4 opacity-80" data-id="element-226">
                <img src="https://cdn.magicpatterns.com/uploads/fNV98cCBQcKZk5qb2Hkk7G/VISA.png" alt="VISA" className="h-6 w-auto object-contain" data-id="element-227" />
                <img src="https://cdn.magicpatterns.com/uploads/pyX1ZaboBbkYDwwZiV7vr7/mastercard.webp" alt="Mastercard" className="h-6 w-auto object-contain" data-id="element-228" />
                <div className="h-6 w-10 bg-[#016FD0] rounded flex items-center justify-center font-bold text-white text-[6px]" data-id="element-229">
                  AMEX
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/iNMH1DKK24VXHynBrVGPZq/naranja.png" alt="Naranja" className="h-6 w-auto object-contain" data-id="element-230" />
                <div className="h-6 w-10 bg-[#008248] rounded flex items-center justify-center font-bold text-white text-[6px]" data-id="element-231">
                  CABAL
                </div>
              </div>

              <div className="flex justify-center items-center" data-id="element-232">
                <img src="https://cdn.magicpatterns.com/uploads/5UQzX3Bg1aaK5XZJ8qMgYp/medios-de-pago.png" alt="Medios de Pago" className="h-24 md:h-32 w-auto object-contain" data-id="element-233" />
              </div>

              {/* Mercado Pago Button */}
              <button onClick={handlePurchase} className="w-full bg-[#009EE3] text-white p-4 rounded-2xl shadow-lg hover:bg-[#0087C1] transition-all flex items-center gap-4 text-left group pb-[16px]" data-id="element-234">
                <div className="bg-white p-2 rounded-full shadow-inner group-hover:scale-110 transition-transform" data-id="element-235">
                  <Handshake className="w-6 h-6 text-[#009EE3]" data-id="element-236" />
                </div>
                <div data-id="element-237">
                  <p className="font-black text-lg leading-none uppercase" data-id="element-238">
                    PAGÁ CON MERCADO PAGO
                  </p>
                  <p className="text-xs opacity-90" data-id="element-239">
                    Cuotas sin Interés y seguridad garantizada
                  </p>
                </div>
              </button>
            </div>

            {/* Redesigned Trust Banner */}
            <div className="bg-[#041122]/90 backdrop-blur-md text-white py-12 px-6 overflow-hidden rounded-[3rem] border-4 border-[#D4AF37]/20 pt-[48px]" data-id="element-240">
              <div className="max-w-6xl mx-auto" data-id="element-241">
                <div className="grid lg:grid-cols-[auto_1fr_auto] gap-10 items-center" data-id="element-242">
                  {/* Left: Guarantee Seal */}
                  <div className="relative shrink-0 mx-auto" data-id="element-243">
                    <img src="https://cdn.magicpatterns.com/uploads/wHZDSnets98iTAM62U8Kre/garantia-sello.png" alt="Garantía 7 Días" className="w-40 h-40 object-contain drop-shadow-2xl" data-id="element-244" />
                  </div>

                  {/* Center: Compra Segura */}
                  <div className="text-left pl-[20px] pr-[20px] space-y-[8px]" data-id="element-245">
                    <div className="flex items-center gap-2 text-[#28CD3E]" data-id="element-246">
                      <CheckCircle2 className="w-6 h-6" data-id="element-247" />
                      <h4 className="text-2xl font-black uppercase tracking-tight" data-id="element-248">
                        COMPRA SEGURA
                      </h4>
                    </div>
                    <h5 className="text-xl font-bold uppercase tracking-wide" data-id="element-249">
                      GARANTÍA INCONDICIONAL
                    </h5>
                    <p className="text-sm text-white/70 leading-relaxed max-w-md" data-id="element-250">
                      Garantía de satisfacción total. Si el contenido no cumple
                      tus expectativas, te devolvemos el dinero sin preguntas.
                    </p>
                  </div>

                  {/* Right: Mercado Libre Verified */}
                  <div className="flex flex-col items-center gap-4 bg-white p-4 rounded-[2rem] border border-white/10 shadow-xl" data-id="element-251">
                    <img src="https://cdn.magicpatterns.com/uploads/7md84kaW1kCVoHpQDKEEji/es-seguro-comprar-en-mercado-libre-v0-f57o8o5uoudc1.webp" alt="Vendedor Verificado" className="w-full max-w-[320px] h-auto rounded-xl" data-id="element-252" />
                  </div>
                </div>

                {/* Bottom Line */}
                <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 pl-[20px] pr-[20px]" data-id="element-253">
                  <div className="flex items-center gap-3" data-id="element-254">
                    <Calendar className="w-6 h-6 text-[#FFD200]" data-id="element-255" />
                    <span className="font-black uppercase tracking-tight text-[12px]" data-id="element-256">
                      GARANTÍA TOTAL DE 7 DÍAS{' '}
                      <span className="font-normal opacity-70" data-id="element-257">
                        (reembolso garantizado)
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-258">
                    <InfinityIcon className="w-6 h-6 text-[#FFD200]" data-id="element-259" />
                    <span className="text-sm font-black uppercase tracking-tight" data-id="element-260">
                      ACCESO DE POR VIDA{' '}
                      <span className="font-normal opacity-70" data-id="element-261">
                        al contenido completo
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </ScrollReveal>

        {/* Final CTA */}
        <ScrollReveal data-id="element-262">
          <section className="mt-40 text-center pb-20" data-id="element-263">
            <h3 className="text-5xl md:text-7xl font-black mb-12 text-[#2F5233] font-serif leading-tight" data-id="element-264">
              ¿Vas a seguir postergando tu sueño o vas a empezar a crear?
            </h3>
            <p className="text-2xl md:text-3xl text-[#8D7B6D] mb-20 max-w-4xl mx-auto leading-relaxed" data-id="element-265">
              No dejes que tu talento se oxide por miedo a equivocarte o por
              culpa de tutoriales confusos. Recupera tu confianza, domina la
              máquina de coser y construye un futuro creativo desde la comodidad
              de tu hogar.
            </p>
            <button onClick={scrollToPurchase} className="bg-[#E07A5F] text-white font-black px-20 py-12 rounded-[3rem] shadow-2xl hover:bg-[#D1694E] active:scale-[0.98] transition-all flex items-center justify-center uppercase mx-auto animate-slow-pulse text-[14px] gap-[24px] pt-[10px] pb-[10px]" data-id="element-266">
              SÍ, QUIERO ENTRAR A ALMA TEXTIL AHORA
            </button>
          </section>
        </ScrollReveal>

        <FAQSection data-id="element-267" />

        <CommentSection data-id="element-268" />
      </main>

      <footer className="bg-white/10 backdrop-blur-sm py-24 border-t border-[#2F5233]/10 text-center text-[#8D7B6D] text-lg" data-id="element-269">
        <ScrollReveal data-id="element-270">
          <p className="mb-4" data-id="element-271">
            © {new Date().getFullYear()} Hilos que Enamoran. Todos los derechos
            reservados.
          </p>
          <p className="max-w-2xl mx-auto opacity-60" data-id="element-272">
            Este sitio no es parte de Facebook ni de Google Inc.
          </p>
        </ScrollReveal>
      </footer>
    </div>;
};
export { App };